import React, { useState } from "react";
import {
  AreaLeft,
  AreaRight,
  HeaderContainer,
  HeaderNav,
  NavLink,
  AuthButtonsContainer,
  MobileIcon,
} from "./styles";
import {
  RiAccountPinCircleLine,
  RiAddCircleLine,
  RiMenu2Fill,
} from "react-icons/ri";
import Logo from "../../assets/logo";
import { NavButton } from "../../styles";
import Dropdown from "../dropdown";

const Header = () => {
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  return (
    <HeaderContainer>
      <AreaLeft>
        <Logo />
      </AreaLeft>
      <HeaderNav isVisible={isMenuVisible}>
        <NavLink href="#sobre-apis">Sobre as APIs</NavLink>
        <NavLink href="#publico-alvo">Público alvo</NavLink>
        <NavLink href="#como-funciona">Como funciona</NavLink>
        <Dropdown />
        <NavLink href="#faq">FAQ</NavLink>
        <NavLink href="#colaboracao">Colaboração</NavLink>
        <NavLink
          mobileOnly
          href="https://amei.homolog.kubernetes.sebrae.com.br/auth/realms/externo/login-actions/registration?client_id=na-palma-frontend&tab_id=ElID0ynvsG8"
        >
          <RiAddCircleLine color="#ffffff" />
          Cadastre-se
        </NavLink>
        <NavLink
          mobileOnly
          href="https://amei.homolog.kubernetes.sebrae.com.br/auth/realms/externo/protocol/openid-connect/auth?client_id=na-palma-frontend&redirect_uri=https%3A%2F%2Flocalhost%3A3000%2F&state=2f997d24-75ee-4d08-a19c-16cc7dbd0df1&response_mode=fragment&response_type=code&scope=openid"
        >
          <RiAccountPinCircleLine color="#ffffff" />
          Login
        </NavLink>
      </HeaderNav>
      <AreaRight>
        <MobileIcon onClick={toggleMenu}>
          <RiMenu2Fill size={22} color="white" />
        </MobileIcon>
        <AuthButtonsContainer>
          <NavButton href="https://amei.homolog.kubernetes.sebrae.com.br/auth/realms/externo/login-actions/registration?client_id=na-palma-frontend&tab_id=ElID0ynvsG8">
            <RiAddCircleLine color="#ffffff" />
            Cadastre-se
          </NavButton>
          <NavButton href="https://amei.homolog.kubernetes.sebrae.com.br/auth/realms/externo/protocol/openid-connect/auth?client_id=na-palma-frontend&redirect_uri=https%3A%2F%2Flocalhost%3A3000%2F&state=2f997d24-75ee-4d08-a19c-16cc7dbd0df1&response_mode=fragment&response_type=code&scope=openid">
            <RiAccountPinCircleLine color="#ffffff" />
            Login
          </NavButton>
        </AuthButtonsContainer>
      </AreaRight>
    </HeaderContainer>
  );
};

export default Header;
